import logout from './logout.png'

const commonIcons = {
  logout
}
export default commonIcons
